export enum EventsEnum {
  CHANGE = 'change',
  COMPLETED = 'completed',
  FAIL = 'fail',
}

export interface ComponentProps {
  iframeSrc: string;
  process: boolean;
}



// WEBPACK FOOTER //
// ./src/components/intalent/test/types.ts